import request from '@/utils/request'
/**
 *
 * 门店
 *
 **/
// 查询列表接口
export const getShopPage = (params: any) => {
  return request({
    url: '/shop/page',
    method: 'get',
    params
  })
}

// 删除接口
export const deleteShop = (ids: string) => {
  return request({
    url: '/shop',
    method: 'delete',
    params: { ids }
  })
}

// 批量删除接口
export const deleteBatch = (ids: string) => {
  return request({
    url: `/shop/batch/${ids}`,
    method: 'delete',
  })
}

// 修改接口
export const editShop = (params: any) => {
  return request({
    url: '/shop',
    method: 'put',
    data: { ...params }
  })
}

// 新增接口
export const addShop = (params: any) => {
  return request({
    url: '/shop',
    method: 'post',
    data: { ...params }
  })
}

// 查询详情
export const queryShopById = (id: string | (string | null)[]) => {
  return request({
    url: `/shop/${id}`,
    method: 'get'
  })
}


// 查菜品列表的接口
export const queryShopList = () => {
  return request({
    url: '/shop/list',
    method: 'get',
  })
}
